module.exports = __webpack_public_path__ + "static/frying_pan-75047e9d598b7cb364cc2d4debadb95d.png";